import React, { useEffect, useState } from 'react';
import { usePermissions } from '../../../contexts/PermissionsContext';
import {
  addArea,
  addCustomerCateogry,
  addDeliveryStatus,
  addDistrict,
  addLogisticLine,
  addOrderStatus,
  addOrigin,
  addPaymentMethod,
  addPaymentStatus,
  addProcessCategory,
  addProductCategory,
  addProcessLocation,
  addProductUnit,
  addSpecificationUnit,
  deleteArea,
  deleteCustomerCateogry,
  deleteDeliveryStatus,
  deleteDistrict,
  deleteLogisticLine,
  deleteOrderStatus,
  deleteOrigin,
  deletePaymentMethod,
  deletePaymentStatus,
  deleteProcessCategory,
  deleteProductCategory,
  deleteProcessLocation,
  deleteProductUnit,
  deleteSpecificationUnit,
  // addSpecificationValue,
  exportMasterData,
  fetchAreas,
  fetchCustomerCateogries,
  fetchDeliveryStatuses,
  fetchDistricts,
  fetchLogisticLines,
  fetchOrderStatuses,
  fetchOrigins,
  fetchPaymentMethods,
  fetchPaymentStatuses,
  fetchProcessCategories,
  fetchProductCategories,
  fetchProcessLocations,
  fetchProductUnits,
  fetchSpecificationUnits,
  importMasterData,
  updateArea,
  updateCustomerCateogry,
  updateDeliveryStatus,
  updateDistrict,
  updateLogisticLine,
  updateOrderStatus,
  updateOrigin,
  updatePaymentMethod,
  updatePaymentStatus,
  updateProcessCategory,
  updateProductCategory,
  updateProcessLocation,
  updateProductUnit,
  updateSpecificationUnit,
  // updateSpecificationValue,
} from '../services/masterDataService';
import CustomerCategory from '../components/CustomerCategory';
import Area from '../components/Area';
import District from '../components/District';
import DeliveryStatus from '../components/DeliveryStatus';
import LogisticLine from '../components/LogisticLine';
import Origin from '../components/Origin';
import PaymentStatus from '../components/PaymentStatus';
import ProcessLocation from '../components/ProcessLocation';
// import ProductCategory from "../components/ProcessCategory";
import SpecificationUnit from '../components/SpecificationUnit';
// import SpecificationValue from "../components/SpecificationUnit";
import OrderStatus from '../components/OrderStatus';
import PaymentMethod from '../components/PaymentMethod';
import Loader from '../../../components/Loader'; // Import your loader
import ProcessCategory from '../components/ProcessCategory';
import EditMasterdataModal from '../components/EditMasterdataModal';
import { showErrorToast, showSuccessToast } from '../../../utils/toastHelper';
import AddMasterDataModal from '../components/AddMasterDataModal';
import { useTranslation } from 'react-i18next';
import ImportMasterDataModal from '../components/ImportMasterDataModal';
import Pagination from '../../../components/Pagination';
import ProductUnit from '../components/ProductUnit';
import DeleteMasterDataModal from '../components/DeleteMasterDataModal';
import ProductCategory from '../components/ProductCategory';
import { printTable } from '../../../utils/printUtils';
import FileNames from '../../../constants/fileNames';

export default function MasterData() {
  const { t } = useTranslation('MasterData');
  const { permissions } = usePermissions();
  const [pagination, setPagination] = useState({
    total: 0,
    current_page: 1,
    last_page: 1,
    per_page: 20,
  });
  const [loading, setLoading] = useState(false);
  const [selectedKey, setSelectedKey] = useState(
    'MASTER_DATA_CUSTOMER_CATEGORY'
  );
  console.log('selectedKey>>>>>>', selectedKey);
  const [isImportModalOpen, setImportModalOpen] = useState(false);
  const [customerCateogries, setCustomerCateogries] = useState({});
  const [areas, setAreas] = useState([]);
  console.log('areas???????', areas);
  const [districts, setDistricts] = useState({});
  const [logisticLines, setLogisticLines] = useState({});
  const [paymentMethods, setPaymentMethods] = useState({});
  const [processCategories, setProcessCategories] = useState([]);
  const [productCategories, setProductCategories] = useState([]);
  const [origins, setOrigins] = useState({});
  // const [specificationValues, setSpecificationValues] = useState({});
  const [productUnits, setProductUnits] = useState({});
  const [specificationUnits, setSpecificationUnits] = useState({});
  const [processLocations, setProcessLocations] = useState([]);
  const [orderStatuses, setOrderStatuses] = useState({});
  const [deliveryStatuses, setDeliveryStatuses] = useState({});
  const [paymentStatuses, setPaymentStatuses] = useState({});
  const [modalData, setModalData] = useState({});
  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [importLoading, setimportLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isDisable, setIsDisable] = useState(false);
  const [printLoading, setPrintLoading] = useState(false);
  const keysArray = [
    {
      key: 'MASTER_DATA_CUSTOMER_CATEGORY',
      label: t('CUSTOMERCATEGORY'),
    },
    { key: 'MASTER_DATA_AREA', label: t('AREA') },
    { key: 'MASTER_DATA_DISTRICT', label: t('DISTRICT') },
    { key: 'MASTER_DATA_LOGISTIC_LINE', label: t('LOGISTICLINE') },
    { key: 'MASTER_DATA_PAYMENT_METHOD', label: t('PAYMENTMETHOD') },
    {
      key: 'MASTER_DATA_PROCESS_CATEGORY',
      label: t('PROCESSCATEGORY'),
    },
    {
      key: 'MASTER_DATA_PRODUCT_CATEGORY',
      label: t('PRODUCTCATEGORY'),
    },
    { key: 'MASTER_DATA_ORIGIN', label: t('ORIGIN') },
    {
      key: 'MASTER_DATA_SPECIFICATION_UNIT',
      label: t('SPECIFICATIONUNIT'),
    },
    {
      key: 'MASTER_DATA_PRODUCT_UNIT',
      label: t('PRODUCTUNIT'),
    },
    {
      key: 'MASTER_DATA_PROCESS_LOCATION',
      label: t('PROCESSLOCATION'),
    },
    { key: 'MASTER_DATA_ORDER_STATUS', label: t('ORDERSTATUS') },
    { key: 'MASTER_DATA_DELIVERY_STATUS', label: t('DELIVERYSTATUS') },
    { key: 'MASTER_DATA_PAYMENT_STATUS', label: t('PAYMENTSTATUS') },
  ];
  const fetchData = async (page = 1) => {
    setLoading(true);

    try {
      const per_page = 50;
      const query = {
        page,
        per_page,
        search: searchQuery,
      };

      const fetchFunctions = {
        MASTER_DATA_CUSTOMER_CATEGORY: fetchCustomerCateogries,
        MASTER_DATA_AREA: fetchAreas,
        MASTER_DATA_DISTRICT: fetchDistricts,
        MASTER_DATA_DELIVERY_STATUS: fetchDeliveryStatuses,
        MASTER_DATA_LOGISTIC_LINE: fetchLogisticLines,
        MASTER_DATA_ORDER_STATUS: fetchOrderStatuses,
        MASTER_DATA_ORIGIN: fetchOrigins,
        MASTER_DATA_PAYMENT_METHOD: fetchPaymentMethods,
        MASTER_DATA_PAYMENT_STATUS: fetchPaymentStatuses,
        MASTER_DATA_PROCESS_LOCATION: fetchProcessLocations,
        MASTER_DATA_PROCESS_CATEGORY: fetchProcessCategories,
        MASTER_DATA_PRODUCT_CATEGORY: fetchProductCategories,
        MASTER_DATA_SPECIFICATION_UNIT: fetchSpecificationUnits,
        // MASTER_DATA_SPECIFICATION_VALUE: fetchSpecificationValues,
        MASTER_DATA_PRODUCT_UNIT: fetchProductUnits,
      };
      // Mapping for state setter functions
      const stateSetters = {
        MASTER_DATA_CUSTOMER_CATEGORY: setCustomerCateogries,
        MASTER_DATA_AREA: setAreas,
        MASTER_DATA_DISTRICT: setDistricts,
        MASTER_DATA_LOGISTIC_LINE: setLogisticLines,
        MASTER_DATA_PAYMENT_METHOD: setPaymentMethods,
        MASTER_DATA_PROCESS_CATEGORY: setProcessCategories,
        MASTER_DATA_PRODUCT_CATEGORY: setProductCategories,
        MASTER_DATA_ORIGIN: setOrigins,
        // MASTER_DATA_SPECIFICATION_VALUE: setSpecificationValues,
        MASTER_DATA_PRODUCT_UNIT: setProductUnits,
        MASTER_DATA_SPECIFICATION_UNIT: setSpecificationUnits,
        MASTER_DATA_PROCESS_LOCATION: setProcessLocations,
        MASTER_DATA_ORDER_STATUS: setOrderStatuses,
        MASTER_DATA_DELIVERY_STATUS: setDeliveryStatuses,
        MASTER_DATA_PAYMENT_STATUS: setPaymentStatuses,
      };

      // Mapping for response keys
      const responseKeys = {
        MASTER_DATA_CUSTOMER_CATEGORY: 'customer_categories',
        MASTER_DATA_AREA: 'areas',
        MASTER_DATA_DISTRICT: 'districts',
        MASTER_DATA_DELIVERY_STATUS: 'delivery_statuses',
        MASTER_DATA_LOGISTIC_LINE: 'logistic_lines',
        MASTER_DATA_ORDER_STATUS: 'order_statuses',
        MASTER_DATA_ORIGIN: 'origins',
        MASTER_DATA_PAYMENT_METHOD: 'payment_methods',
        MASTER_DATA_PAYMENT_STATUS: 'payment_statuses',
        MASTER_DATA_PROCESS_LOCATION: 'process_locations',
        MASTER_DATA_PROCESS_CATEGORY: 'process_categories',
        MASTER_DATA_PRODUCT_CATEGORY: 'product_categories',
        MASTER_DATA_SPECIFICATION_UNIT: 'specification_units',
        // MASTER_DATA_SPECIFICATION_VALUE: "specification_values",
        MASTER_DATA_PRODUCT_UNIT: 'product_units',
      };

      if (!fetchFunctions[selectedKey]) {
        console.error('Invalid selectedKey:', selectedKey);
        // showErrorToast("Invalid operation.");
        return;
      }
      let response = await fetchFunctions[selectedKey](query);

      console.log('API Response:', response);
      const key = responseKeys[selectedKey];
      if (response && key && response[key]) {
        if (stateSetters[selectedKey]) {
          stateSetters[selectedKey](response[key]);
        }
        if (selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY') {
          let processCategoriesResponse = await fetchProcessCategories({
            per_page: 9999,
          });
          let processLocationsResponse = await fetchProcessLocations({
            per_page: 9999,
          });
          console.log(
            'API Response processCategoriesResponse:',
            processCategoriesResponse
          );

          if (
            processCategoriesResponse &&
            processCategoriesResponse.process_categories
          ) {
            setProcessCategories(processCategoriesResponse.process_categories);
          }
          if (
            processLocationsResponse &&
            processLocationsResponse.process_locations
          ) {
            setProcessLocations(processLocationsResponse.process_locations);
          }
        }
        if (selectedKey === 'MASTER_DATA_DISTRICT') {
          let areasResponse = await fetchAreas({
            per_page: 9999,
          });

          if (areasResponse && areasResponse.areas) {
            setAreas(areasResponse.areas);
          }
        }
        setPagination({
          total: response.pagination.total,
          current_page: response.pagination.current_page,
          last_page: response.pagination.last_page,
          per_page: response.pagination.per_page,
        });
      } else {
        console.warn(`No valid data found for key: ${key}`);
      }

      // const [
      //   customerCateogriesResponse,
      //   areasResponse,
      //   districtsResponse,
      //   logisticLinesResponse,
      //   paymentMethodsResponse,
      //   processCategoriesResponse,
      //   originsResponse,
      //   specificationValuesResponse,
      //   specificationUnitsResponse,
      //   processLocationsResponse,
      //   orderStatusesResponse,
      //   deliveryStatusesResponse,
      //   paymentStatusesResponse,
      // ] = await Promise.all([
      //   fetchCustomerCateogries(query),
      //   fetchAreas(query),
      //   fetchDistricts(query),
      //   fetchLogisticLines(query),
      //   fetchPaymentMethods(query),
      //   fetchProcessCategories(query),
      //   fetchOrigins(query),
      //   fetchSpecificationValues(query),
      //   fetchSpecificationUnits(query),
      //   fetchProcessLocations(query),
      //   fetchOrderStatuses(query),
      //   fetchDeliveryStatuses(query),
      //   fetchPaymentStatuses(query),
      // ]);

      // if (customerCateogriesResponse.customer_categories) {
      //   setCustomerCateogries(customerCateogriesResponse.customer_categories);
      // }
      // if (areasResponse.areas) {
      //   setAreas(areasResponse.areas);
      // }
      // if (districtsResponse.districts) {
      //   setDistricts(districtsResponse.districts);
      // }
      // if (logisticLinesResponse.logistic_lines) {
      //   setLogisticLines(logisticLinesResponse.logistic_lines);
      // }
      // if (paymentMethodsResponse.payment_methods) {
      //   setPaymentMethods(paymentMethodsResponse.payment_methods);
      // }
      // if (processCategoriesResponse.process_categories) {
      //   setProcessCategories(processCategoriesResponse.process_categories);
      // }
      // if (originsResponse.origins) {
      //   setOrigins(originsResponse.origins);
      // }
      // if (specificationValuesResponse.specification_values) {
      //   setSpecificationValues(specificationValuesResponse.specification_values);
      // }
      // if (specificationUnitsResponse.specification_units) {
      //   setSpecificationUnits(specificationUnitsResponse.specification_units);
      // }
      // if (processLocationsResponse.process_locations) {
      //   setProcessLocations(processLocationsResponse.process_locations);
      // }
      // if (orderStatusesResponse.order_statuses) {
      //   setOrderStatuses(orderStatusesResponse.order_statuses);
      // }
      // if (deliveryStatusesResponse.delivery_statuses) {
      //   setDeliveryStatuses(deliveryStatusesResponse.delivery_statuses);
      // }
      // if (paymentStatusesResponse.payment_statuses) {
      //   setPaymentStatuses(paymentStatusesResponse.payment_statuses);
      // }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchData();
  // }, [selectedKey]);
  useEffect(() => {
    fetchData(pagination.current_page);
  }, [pagination.current_page]);
  const paginate = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= pagination.last_page) {
      setPagination((prev) => ({
        ...prev,
        current_page: pageNumber,
      }));
    }
  };
  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      // fetchData(1);
      if (pagination.current_page === 1) {
        fetchData(1); // direct call
      } else {
        setPagination((prev) => ({
          ...prev,
          current_page: 1,
        }));
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [selectedKey, searchQuery]);
  // const handleSelection = (key, e) => {
  //   e.preventDefault(); // Prevents the default action of the anchor tag
  //   setSelectedKey(key);
  // };

  const handleSelection = (key, e) => {
    setSelectedKey(key);
    e.preventDefault();
    // setSelectedSection(key);
    // setAddModalOpen(true); // Open modal on selection
  };
  const handleOpenModal = (modalType, data) => {
    setModalData(data);

    if (modalType === 'edit') {
      setEditModalOpen(true);
    } else if (modalType === 'add') {
      setAddModalOpen(true);
    } else if (modalType === 'import') {
      setImportModalOpen(true);
    } else if (modalType === 'delete') {
      setDeleteModalOpen(true);
    }
  };
  const handleCloseModal = (modalType) => {
    // console.log("handle on close ", modalType);
    //  if (modalType === "add") {
    //   setAddModalOpen(false);
    // }
    if (modalType === 'edit') {
      setEditModalOpen(false);
    } else if (modalType === 'add') {
      setAddModalOpen(false);
    } else if (modalType === 'import') {
      setImportModalOpen(false);
    } else if (modalType === 'delete') {
      setDeleteModalOpen(false);
    }
    // setAddModalOpen(false);
    setModalData({});
  };
  //  const handleEditSubmit =async (data,id)=>{
  // let response;
  //   if(selectedKey=='MASTER_DATA_CUSTOMER_CATEGORY'){
  //     response = await updateCustomerCateogry(data,id)
  //     setCustomerCateogries((prevCategories) =>
  //       prevCategories.map((customerCategory) =>
  //         customerCategory.id === id ? response.customer_categories : customerCategory
  //       )
  //     );
  //     showSuccessToast(response.message)
  //   }else if(selectedKey ==='MASTER_DATA_AREA'){
  //     response = await updateArea(data,id)
  //     setAreas((prevAreas) =>
  //       prevAreas.map((areas) =>
  //         areas.id === id ? response.areas : areas
  //       )
  //     );
  //     showSuccessToast(response.message);
  //   }else if(selectedKey ==='MASTER_DATA_DISTRICT'){
  //     response = await updateDistrict(data,id)
  //     setDistricts((prevDistricts) =>
  //       prevDistricts.map((district) =>
  //         district.id === id ? response.districts : districts
  //       )
  //     );
  //      showSuccessToast(response.message);
  //   }
  //   else if(selectedKey ==='MASTER_DATA_DELIVERY_STATUS'){
  //     response = await updateDeliveryStatus(data,id)
  //     showSuccessToast(response.message);
  //   }
  //   else if (selectedKey ==='MASTER_DATA_LOGISTIC_LINE'){
  //     response = await updateLogisticLine(data,id)
  //     setLogisticLines((LogisticLines) =>
  //       LogisticLines.map((LogisticLine) =>
  //         LogisticLine.id === id ? response.logistic_lines : logisticLines
  //       )
  //     );

  //      showSuccessToast(response.message);
  //   }

  //   if(response.success){
  //     handleCloseModal('edit');

  //   }
  //  }

  const handleEditSubmit = async (data, id) => {
    try {
      let response;
      setIsDisable(true);
      // Mapping for API update functions
      const updateFunctions = {
        MASTER_DATA_CUSTOMER_CATEGORY: updateCustomerCateogry,
        MASTER_DATA_AREA: updateArea,
        MASTER_DATA_DISTRICT: updateDistrict,
        MASTER_DATA_DELIVERY_STATUS: updateDeliveryStatus,
        MASTER_DATA_LOGISTIC_LINE: updateLogisticLine,
        MASTER_DATA_ORDER_STATUS: updateOrderStatus,
        MASTER_DATA_ORIGIN: updateOrigin,
        MASTER_DATA_PAYMENT_METHOD: updatePaymentMethod,
        MASTER_DATA_PAYMENT_STATUS: updatePaymentStatus,
        MASTER_DATA_PROCESS_LOCATION: updateProcessLocation,
        MASTER_DATA_PROCESS_CATEGORY: updateProcessCategory,
        MASTER_DATA_PRODUCT_CATEGORY: updateProductCategory,
        MASTER_DATA_SPECIFICATION_UNIT: updateSpecificationUnit,
        MASTER_DATA_PRODUCT_UNIT: updateProductUnit,
      };

      // Mapping for state setter functions
      const stateSetters = {
        MASTER_DATA_CUSTOMER_CATEGORY: setCustomerCateogries,
        MASTER_DATA_AREA: setAreas,
        MASTER_DATA_DISTRICT: setDistricts,
        MASTER_DATA_LOGISTIC_LINE: setLogisticLines,
        MASTER_DATA_PAYMENT_METHOD: setPaymentMethods,
        MASTER_DATA_PROCESS_CATEGORY: setProcessCategories,
        MASTER_DATA_PRODUCT_CATEGORY: setProductCategories,
        MASTER_DATA_ORIGIN: setOrigins,
        // MASTER_DATA_SPECIFICATION_VALUE: setSpecificationValues,
        MASTER_DATA_SPECIFICATION_UNIT: setSpecificationUnits,
        MASTER_DATA_PRODUCT_UNIT: setProductUnits,
        MASTER_DATA_PROCESS_LOCATION: setProcessLocations,
        MASTER_DATA_ORDER_STATUS: setOrderStatuses,
        MASTER_DATA_DELIVERY_STATUS: setDeliveryStatuses,
        MASTER_DATA_PAYMENT_STATUS: setPaymentStatuses,
      };

      // Mapping for response keys
      const responseKeys = {
        MASTER_DATA_CUSTOMER_CATEGORY: 'customer_categories',
        MASTER_DATA_AREA: 'areas',
        MASTER_DATA_DISTRICT: 'districts',
        MASTER_DATA_DELIVERY_STATUS: 'delivery_statuses',
        MASTER_DATA_LOGISTIC_LINE: 'logistic_lines',
        MASTER_DATA_ORDER_STATUS: 'order_statuses',
        MASTER_DATA_ORIGIN: 'origins',
        MASTER_DATA_PAYMENT_METHOD: 'payment_methods',
        MASTER_DATA_PAYMENT_STATUS: 'payment_statuses',
        MASTER_DATA_PROCESS_LOCATION: 'process_locations',
        MASTER_DATA_PROCESS_CATEGORY: 'process_categories',
        MASTER_DATA_PRODUCT_CATEGORY: 'product_categories',
        MASTER_DATA_SPECIFICATION_UNIT: 'specification_units',
        // MASTER_DATA_SPECIFICATION_VALUE: "specification_values",
        MASTER_DATA_PRODUCT_UNIT: 'product_units',
      };

      if (!updateFunctions[selectedKey]) {
        console.error('Invalid selectedKey:', selectedKey);
        // showErrorToast("Invalid operation.");
        return;
      }
      response = await updateFunctions[selectedKey](data, id);

      console.log('API Response:', response);
      const key = responseKeys[selectedKey];
      if (response && key && response[key]) {
        if (stateSetters[selectedKey]) {
          stateSetters[selectedKey]((prevState) =>
            prevState.map((item) => (item.id === id ? response[key] : item))
          );
        }
      } else {
        console.warn(`No valid data found for key: ${key}`);
      }

      if (response && response.success) {
        showSuccessToast(response.message);

        handleCloseModal('edit');
      }
    } catch (error) {
      console.error('Error updating data:', error);
      showErrorToast('An error occurred while updating.');
    } finally {
      setIsDisable(false);
    }
  };

  const handleImportMasterData = async (formData) => {
    setimportLoading(true);

    console.log('form data:', formData);
    const response = await importMasterData(formData);
    if (response.success) {
      console.log('response', response);
      setimportLoading(false);
      // handleCloseModal("import");
      fetchData();
      return response;
    }
    setimportLoading(false);
    return false;
  };

  const handleAddSubmit = async (data) => {
    try {
      let response;
      setIsDisable(true);
      // Mapping for API add functions
      const addFunctions = {
        MASTER_DATA_CUSTOMER_CATEGORY: addCustomerCateogry,
        MASTER_DATA_AREA: addArea,
        MASTER_DATA_DISTRICT: addDistrict,
        MASTER_DATA_DELIVERY_STATUS: addDeliveryStatus,
        MASTER_DATA_LOGISTIC_LINE: addLogisticLine,
        MASTER_DATA_ORDER_STATUS: addOrderStatus,
        MASTER_DATA_ORIGIN: addOrigin,
        MASTER_DATA_PAYMENT_METHOD: addPaymentMethod,
        MASTER_DATA_PAYMENT_STATUS: addPaymentStatus,
        MASTER_DATA_PROCESS_LOCATION: addProcessLocation,
        MASTER_DATA_PROCESS_CATEGORY: addProcessCategory,
        MASTER_DATA_PRODUCT_CATEGORY: addProductCategory,
        MASTER_DATA_SPECIFICATION_UNIT: addSpecificationUnit,
        MASTER_DATA_PRODUCT_UNIT: addProductUnit,
      };

      // Mapping for state setter functions (same as in handleEditSubmit)
      const stateSetters = {
        MASTER_DATA_CUSTOMER_CATEGORY: setCustomerCateogries,
        MASTER_DATA_AREA: setAreas,
        MASTER_DATA_DISTRICT: setDistricts,
        MASTER_DATA_LOGISTIC_LINE: setLogisticLines,
        MASTER_DATA_PAYMENT_METHOD: setPaymentMethods,
        MASTER_DATA_PROCESS_CATEGORY: setProcessCategories,
        MASTER_DATA_PRODUCT_CATEGORY: setProductCategories,
        MASTER_DATA_ORIGIN: setOrigins,
        // MASTER_DATA_SPECIFICATION_VALUE: setSpecificationValues,
        MASTER_DATA_SPECIFICATION_UNIT: setSpecificationUnits,
        MASTER_DATA_PRODUCT_UNIT: setProductUnits,
        MASTER_DATA_PROCESS_LOCATION: setProcessLocations,
        MASTER_DATA_ORDER_STATUS: setOrderStatuses,
        MASTER_DATA_DELIVERY_STATUS: setDeliveryStatuses,
        MASTER_DATA_PAYMENT_STATUS: setPaymentStatuses,
      };

      // Mapping for response keys (same as in handleEditSubmit)
      const responseKeys = {
        MASTER_DATA_CUSTOMER_CATEGORY: 'customer_categories',
        MASTER_DATA_AREA: 'areas',
        MASTER_DATA_DISTRICT: 'districts',
        MASTER_DATA_DELIVERY_STATUS: 'delivery_statuses',
        MASTER_DATA_LOGISTIC_LINE: 'logistic_lines',
        MASTER_DATA_ORDER_STATUS: 'order_statuses',
        MASTER_DATA_ORIGIN: 'origins',
        MASTER_DATA_PAYMENT_METHOD: 'payment_methods',
        MASTER_DATA_PAYMENT_STATUS: 'payment_statuses',
        MASTER_DATA_PROCESS_LOCATION: 'process_locations',
        MASTER_DATA_PROCESS_CATEGORY: 'process_categories',
        MASTER_DATA_PRODUCT_CATEGORY: 'product_categories',
        MASTER_DATA_SPECIFICATION_UNIT: 'specification_units',
        // MASTER_DATA_SPECIFICATION_VALUE: "specification_values",
        MASTER_DATA_PRODUCT_UNIT: 'product_units',
      };

      if (!addFunctions[selectedKey]) {
        console.error('Invalid selectedKey:', selectedKey);
        // showErrorToast("Invalid operation.");
        return;
      }

      response = await addFunctions[selectedKey](data);

      const key = responseKeys[selectedKey];
      if (response && key && response[key]) {
        // if (stateSetters[selectedKey]) {
        //   stateSetters[selectedKey]((prevState) => [
        //     ...prevState,
        //     response[key],
        //   ]);
        // }

        fetchData(pagination.current_page);
      } else {
        console.warn(`No valid data found for key: ${key}`);
      }

      // if (response && response.message) {
      //   // showSuccessToast(response.message);
      // }

      if (response && response.success) {
        handleCloseModal('add');
        showSuccessToast(response.message);
        return response;
      }
    } catch (error) {
      console.error('Error adding data:', error);
      showErrorToast('An error occurred while adding.');
    } finally {
      setIsDisable(false);
    }
  };

  const handleDeleteUser = async (id) => {
    let response;
    setIsDisable(true);
    const deleteFunctions = {
      MASTER_DATA_CUSTOMER_CATEGORY: deleteCustomerCateogry,
      MASTER_DATA_AREA: deleteArea,
      MASTER_DATA_DISTRICT: deleteDistrict,
      MASTER_DATA_DELIVERY_STATUS: deleteDeliveryStatus,
      MASTER_DATA_LOGISTIC_LINE: deleteLogisticLine,
      MASTER_DATA_ORDER_STATUS: deleteOrderStatus,
      MASTER_DATA_ORIGIN: deleteOrigin,
      MASTER_DATA_PAYMENT_METHOD: deletePaymentMethod,
      MASTER_DATA_PAYMENT_STATUS: deletePaymentStatus,
      MASTER_DATA_PROCESS_LOCATION: deleteProcessLocation,
      MASTER_DATA_PROCESS_CATEGORY: deleteProcessCategory,
      MASTER_DATA_PRODUCT_CATEGORY: deleteProductCategory,
      MASTER_DATA_SPECIFICATION_UNIT: deleteSpecificationUnit,
      MASTER_DATA_PRODUCT_UNIT: deleteProductUnit,
    };
    const stateSetters = {
      MASTER_DATA_CUSTOMER_CATEGORY: setCustomerCateogries,
      MASTER_DATA_AREA: setAreas,
      MASTER_DATA_DISTRICT: setDistricts,
      MASTER_DATA_LOGISTIC_LINE: setLogisticLines,
      MASTER_DATA_PAYMENT_METHOD: setPaymentMethods,
      MASTER_DATA_PROCESS_CATEGORY: setProcessCategories,
      MASTER_DATA_PRODUCT_CATEGORY: setProductCategories,
      MASTER_DATA_ORIGIN: setOrigins,
      MASTER_DATA_SPECIFICATION_UNIT: setSpecificationUnits,
      MASTER_DATA_PRODUCT_UNIT: setProductUnits,
      MASTER_DATA_PROCESS_LOCATION: setProcessLocations,
      MASTER_DATA_ORDER_STATUS: setOrderStatuses,
      MASTER_DATA_DELIVERY_STATUS: setDeliveryStatuses,
      MASTER_DATA_PAYMENT_STATUS: setPaymentStatuses,
    };
    if (!deleteFunctions[selectedKey]) {
      console.error('Invalid selectedKey:', selectedKey);
      // showErrorToast("Invalid operation.");
      return;
    }
    response = await deleteFunctions[selectedKey](id);

    console.log('user delete', response);
    // handleCloseModal("delete");
    if (response.success) {
      if (stateSetters[selectedKey]) {
        stateSetters[selectedKey]((prevState) =>
          prevState.filter((item) => item.id !== id)
        );
      }
      showSuccessToast(response.message);

      handleCloseModal('delete');
    }
    setIsDisable(false);
  };
  // const handleExportMasterData = async () => {
  //   const response = await exportMasterData({ key: selectedKey });
  //   console.log('response>>>>>>', response);
  // };
  const handleExportMasterData = async () => {
    const data = {
      key: selectedKey,
      search: searchQuery,
    };
    const response = await exportMasterData(data, FileNames.MASTER_DATA_EXPORT);
    // if (response.success) {
    //   showSuccessToast(response.message);
    // }
  };

  const handlePrint = async () => {
    if (!selectedKey) return;

    let headers = [];
    let content = [];
    let title = '';

    switch (selectedKey) {
      case 'MASTER_DATA_CUSTOMER_CATEGORY':
        headers = [t('SR'), t('NAME')];
        content = customerCateogries.map((item, index) => [
          index + 1,
          item.name,
        ]);
        title = t('CUSTOMERCATEGORIES');
        break;
      case 'MASTER_DATA_AREA':
        headers = [t('SR'), t('NAME')];
        content = areas.map((item, index) => [index + 1, item.name]);
        title = t('AREAS');
        break;
      case 'MASTER_DATA_DISTRICT':
        headers = [t('SR'), t('NAME'), t('REGION')];
        content = districts.map((item, index) => [
          index + 1,
          item.name,
          item.region?.name || '',
        ]);
        title = t('DISTRICTS');
        break;
      case 'MASTER_DATA_LOGISTIC_LINE':
        headers = [t('SR'), t('NAME')];
        content = logisticLines.map((item, index) => [index + 1, item.name]);
        title = t('LOGISTICLINES');
        break;
      case 'MASTER_DATA_PAYMENT_METHOD':
        headers = [t('SR'), t('NAME')];
        content = paymentMethods.map((item, index) => [index + 1, item.name]);
        title = t('PAYMENTMETHODS');
        break;
      case 'MASTER_DATA_ORIGIN':
        headers = [t('SR'), t('NAME')];
        content = origins.map((item, index) => [index + 1, item.name]);
        title = t('ORIGINS');
        break;
      case 'MASTER_DATA_ORDER_STATUS':
        headers = [t('SR'), t('NAME')];
        content = orderStatuses.map((item, index) => [index + 1, item.name]);
        title = t('ORDERSTATUSES');
        break;
      case 'MASTER_DATA_DELIVERY_STATUS':
        headers = [t('SR'), t('NAME')];
        content = deliveryStatuses.map((item, index) => [index + 1, item.name]);
        title = t('DELIVERYSTATUSES');
        break;
      case 'MASTER_DATA_PAYMENT_STATUS':
        headers = [t('SR'), t('NAME')];
        content = paymentStatuses.map((item, index) => [index + 1, item.name]);
        title = t('PAYMENTSTATUSES');
        break;
      case 'MASTER_DATA_PROCESS_CATEGORY':
        headers = [t('SR'), t('NAME')];
        content = processCategories.map((item, index) => [
          index + 1,
          item.name,
        ]);
        title = t('PROCESSCATEGORIES');
        break;
      case 'MASTER_DATA_PROCESS_LOCATION':
        headers = [t('SR'), t('NAME')];
        content = processLocations.map((item, index) => [index + 1, item.name]);
        title = t('PROCESSLOCATIONS');
        break;
      case 'MASTER_DATA_PRODUCT_CATEGORY':
        headers = [
          t('SR'),
          t('NAME'),
          t('CODE'),
          t('PROCESSCATEGORY'),
          t('PROCESSLOCATION'),
        ];
        content = productCategories.map((item, index) => [
          index + 1,
          item.name,
          item.code || '',
          item.process_category?.name || '',
          item.process_location?.name || '',
        ]);
        title = t('PRODUCTCATEGORIES');
        break;
      case 'MASTER_DATA_PRODUCT_UNIT':
        headers = [t('SR'), t('NAME')];
        content = productUnits.map((item, index) => [index + 1, item.name]);
        title = t('PRODUCTUNITS');
        break;
      case 'MASTER_DATA_SPECIFICATION_UNIT':
        headers = [t('SR'), t('NAME')];
        content = specificationUnits.map((item, index) => [
          index + 1,
          item.name,
        ]);
        title = t('SPECIFICATIONUNITS');
        break;
      default:
        return;
    }

    await printTable(headers, content, title, setPrintLoading);
  };

  return (
    <main id="master-data" className="master-data-page">
      <section className="main-section">
        <section className="data">
          <div className="row">
            <div className="col-sm-6">
              <div className="left">
                <h1>{t('MASTERDATA')}</h1>
                <div className="input-card">
                  <img src="images/search-icon.svg" alt="" />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder={t('SEARCH')}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="right">
                <div className="filter-container">
                  <div className="button-group">
                    {permissions?.[selectedKey]?.edit_permission === 1 && (
                      <button
                        className="add-btns"
                        onClick={() => handleOpenModal('add')}
                      >
                        + {t('ADD')}
                      </button>
                    )}
                    {permissions?.[selectedKey]?.edit_permission === 1 && (
                      <button onClick={() => handleOpenModal('import', {})}>
                        <img src="images/import.svg" alt="" />
                        {t('IMPORT')}
                      </button>
                    )}
                    <button onClick={() => handleExportMasterData('  ', {})}>
                      <img src="images/export.svg" alt="" />
                      {t('EXPORT')}
                    </button>
                    <button
                      onClick={handlePrint}
                      disabled={printLoading || !selectedKey}
                      className={`px-4 py-2 ${
                        printLoading || !selectedKey
                          ? 'bg-gray-400'
                          : 'bg-purple-500 hover:bg-purple-600'
                      } text-white rounded-lg`}
                    >
                      <img src="images/print.svg" alt="" />
                      {printLoading ? t('PRINTING') + '...' : t('PRINT')}
                    </button>
                    {/* {permissions?.[selectedKey]?.edit_permission === 1 && (
                      <button
                        className="add-btns"
                        onClick={() => handleOpenModal('add')}
                      >
                        + {t('ADD')}
                      </button>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="left-side">
          <ul>
            {keysArray.map(
              ({ key, label }) =>
                permissions?.[key]?.view_permission === 1 && (
                  <li
                    key={key}
                    onClick={(e) => handleSelection(key, e)}
                    className={selectedKey === key ? 'active' : ''}
                  >
                    <a href="">{label}</a>
                    <img src="images/right-icon.svg" alt="" />
                  </li>
                )
            )}
          </ul>
        </div>
        <div className="right-side">
          {loading ? (
            <Loader />
          ) : (
            <>
              {selectedKey === 'MASTER_DATA_CUSTOMER_CATEGORY' && (
                <CustomerCategory
                  customerCateogries={customerCateogries}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_AREA' && (
                <Area
                  areas={areas}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_DISTRICT' && (
                <District
                  districts={districts}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_DELIVERY_STATUS' && (
                <DeliveryStatus
                  deliveryStatuses={deliveryStatuses}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_LOGISTIC_LINE' && (
                <LogisticLine
                  logisticLines={logisticLines}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_ORDER_STATUS' && (
                <OrderStatus
                  orderStatuses={orderStatuses}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_ORIGIN' && (
                <Origin
                  origins={origins}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_PAYMENT_METHOD' && (
                <PaymentMethod
                  paymentMethods={paymentMethods}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_PAYMENT_STATUS' && (
                <PaymentStatus
                  paymentStatuses={paymentStatuses}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_PROCESS_LOCATION' && (
                <ProcessLocation
                  processLocations={processLocations}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_PROCESS_CATEGORY' && (
                <ProcessCategory
                  processCategories={processCategories}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_PRODUCT_CATEGORY' && (
                <ProductCategory
                  productCategories={productCategories}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}

              {selectedKey === 'MASTER_DATA_PRODUCT_UNIT' && (
                <ProductUnit
                  productUnits={productUnits}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              {selectedKey === 'MASTER_DATA_SPECIFICATION_UNIT' && (
                <SpecificationUnit
                  specificationUnits={specificationUnits}
                  handleOpenModal={handleOpenModal}
                  pagination={pagination}
                />
              )}
              <Pagination
                currentPage={pagination.current_page}
                totalPages={pagination.last_page}
                paginate={paginate}
                loading={loading}
              />
            </>
          )}
        </div>

        {/* <!-- Modal --> */}
        <EditMasterdataModal
          isOpen={isEditModalOpen}
          onClose={handleCloseModal}
          selectedKey={selectedKey}
          modalData={modalData}
          handleEditSubmit={handleEditSubmit}
          isDisable={isDisable}
          processCategories={processCategories}
          processLocations={processLocations}
          areas={areas}
        />
        <AddMasterDataModal
          isOpen={isAddModalOpen}
          onClose={handleCloseModal}
          selectedKey={selectedKey}
          handleAddSubmit={handleAddSubmit}
          isDisable={isDisable}
          processCategories={processCategories}
          processLocations={processLocations}
          areas={areas}
        />

        <ImportMasterDataModal
          isOpen={isImportModalOpen}
          onClose={handleCloseModal}
          selectedKey={selectedKey}
          handleImportMasterData={handleImportMasterData}
          importLoading={importLoading}
          // customerCategory={customerCategory}
          // sample="customerGroups"
        />
        <DeleteMasterDataModal
          isOpen={isDeleteModalOpen}
          onClose={handleCloseModal}
          selectedKey={selectedKey}
          modalData={modalData}
          deleteUser={handleDeleteUser}
          isDisable={isDisable}
        />
      </section>
    </main>
  );
}
